import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'jhi-column-filter-text-with-match-options',
    template: `
		<form #f='ngForm'>
			<div class="form-check">
				<input class="form-check-input" type="radio" id="radio-0" name="option-group"
					   [value]="MatchType.STARTSWITH" [(ngModel)]="filter.matchType">
				<label class="form-check-label" for="radio-0">
					{{ 'column-filter.starts.with.placeholder' | translate }}
				</label>
			</div>
            <div class="form-check">
                <input class="form-check-input" type="radio" id="radio-1" name="option-group"
                       [value]="MatchType.ENDSWITH" [(ngModel)]="filter.matchType">
                <label class="form-check-label" for="radio-1">
                    {{ 'column-filter.ends.with' | translate }}
                </label>
            </div>
			<div class="form-check">
				<input class="form-check-input" type="radio" id="radio-2" name="option-group"
					   [value]="MatchType.EXACTMATCH" [(ngModel)]="filter.matchType">
				<label class="form-check-label" for="radio-2">
                    {{ 'column-filter.exact.match' | translate }}
				</label>
			</div>
			<div class="form-check">
				<input class="form-check-input" type="radio" id="radio-3" name="option-group"
					   [value]="MatchType.CONTAINS" [(ngModel)]="filter.matchType">
				<label class="form-check-label" for="radio-3">
                    {{ 'column-filter.contains' | translate }}
				</label>
			</div>
			<br/>
			<input type="text" class="form-control" placeholder="{{textPlaceHolder | translate}}" [(ngModel)]="filter.value" name="{{filter.key}}">
			<br/>
			<div class="footer text-center"><br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button class="btn btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterTextWithMatchOptionsComponent implements OnInit {
    MatchType = MatchType;
    @Input() filter: any;

    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();
    textPlaceHolder: string;

    ngOnInit(): void {
        this.textPlaceHolder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.contains.text.placeholder';
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        this.filter.value = '';
        this.onReset.emit();
    }
}

export enum MatchType {
    STARTSWITH = 'STARTSWITH',
    EXACTMATCH = 'EXACTMATCH',
    CONTAINS = 'CONTAINS',
    ENDSWITH = 'ENDSWITH'
}
